import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ServiceListChild from "./ServiceListChild";

const ServiceList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ServiceListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ServiceList;
